export default "__VITE_ASSET__ea717344__"